class ReviewController {
    /*@ngInject*/
    constructor($log, $rootScope, CommonService) {
        $log.debug('ReviewController initialized');
        this.requestPending = false;
        this.commonService = CommonService;
        this.showAllReviews = false;
        this.isLoggedIn = false;

        $rootScope.$on('personalizeRequestSuccess', () => {
            this.isLoggedIn = this.commonService.getPersonalizeRequestResponse().isLoggedIn;
        });
    }

    getIsLoggedIn() {
        return this.isLoggedIn;
    }

    showAll() {
        this.showAllReviews = true;
    }

    submit(form) {
        this.requestPending = true;
        form.$$element.submit();
    }
}

export default ReviewController;
